export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[520px] md:min-h-[620px] flex items-center bg-background-50 overflow-hidden pt-[64px]"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/40 rounded-full blur-3xl -translate-y-1/4 translate-x-1/4"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/30 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4">
              <i className="ri-fire-line text-sm"></i>
              <span>玄幻 · 恋爱 · 热血</span>
            </div>

            <h1 className="text-2xl md:text-3xl lg:text-4xl font-black text-foreground-950 leading-tight mb-3">
              酷看漫画 · 韩漫日漫国漫分类大全
            </h1>

            <p className="text-base md:text-lg text-primary-500 font-semibold mb-4">
              找好看的漫画，一搜即达
            </p>

            <div className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-xl mx-auto lg:mx-0 space-y-2">
              <p>
                酷看漫画精心整理<strong>韩漫、日漫、国漫</strong>三大类别的热门作品，覆盖玄幻、恋爱、热血、悬疑、搞笑等多种类型。
                无论你是喜欢追更热门连载，还是想重温经典佳作，这里都有你想要的。每日更新推荐，让你不错过任何一部好看的漫画。
              </p>
              <p>
                本站持续追踪全网热门漫画动态，每周更新推荐榜单，帮你快速发现当下最受欢迎的口碑之作。
              </p>
            </div>

            <div className="flex flex-wrap items-center gap-4 md:gap-6 justify-center lg:justify-start mb-6">
              <div className="flex items-center gap-2">
                <span className="text-2xl md:text-3xl font-black text-primary-500">2000+</span>
                <span className="text-xs md:text-sm text-foreground-500">部漫画收录</span>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl md:text-3xl font-black text-accent-500">每日</span>
                <span className="text-xs md:text-sm text-foreground-500">更新推荐</span>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl md:text-3xl font-black text-primary-500">全免费</span>
                <span className="text-xs md:text-sm text-foreground-500">在线阅读</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
              >
                <i className="ri-fire-line"></i>
                查看热门排行
              </a>
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 border-2 border-primary-500 text-primary-600 font-semibold rounded-lg hover:bg-primary-50 transition-colors duration-200 whitespace-nowrap"
              >
                <i className="ri-grid-line"></i>
                浏览分类索引
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[420px] lg:max-w-[480px]">
            <div className="relative aspect-[4/5] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Dynamic%20manga%20reading%20scene%20with%20vibrant%20illustration%20style%2C%20young%20characters%20in%20modern%20outfits%20surrounded%20by%20floating%20comic%20panels%20and%20speech%20bubbles%2C%20warm%20energetic%20color%20palette%20with%20coral%20red%20and%20golden%20accents%2C%20clean%20white%20background%20with%20subtle%20motion%20lines%2C%20anime-inspired%20art%20style%20with%20bold%20linework%20and%20dynamic%20composition%2C%20editorial%20quality%20illustration&width=960&height=1200&seq=hero-manga-001&orientation=portrait"
                alt="酷看漫画 - 韩漫日漫国漫免费在线阅读"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/20 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}